import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        title: `Tiket no. kendala ${_ctx.noIssue} berhasil diselesaikan!`,
        message: "Kendala sudah ditandai dengan status selesai.",
        image: "ill_badge_success",
        textSuccess: "Oke, mengerti",
        class: "px-8",
        customWidth: "400px",
        onSubmit: _ctx.onSubmitModal,
        customButton: "w-full",
        customParentButton: "w-full",
        customWrapperButton: "w-full px-6",
        imageWidth: 36,
        imageHeight: 36
      }, null, 8, ["title", "onSubmit"]))
    : _createCommentVNode("", true)
}